import { render, staticRenderFns } from "./opera.vue?vue&type=template&id=6ce955c0"
import script from "./opera.vue?vue&type=script&lang=js"
export * from "./opera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports